module.exports = __webpack_public_path__ + "img/iso6336-5-2003_fig03a.ae5148da.png";